export enum InputActionTypes {
  SET_THOUGHT  = '@@input/SET_THOUGHT',
  SET_MODE     = '@@input/SET_MODE',
  SET_LOADING  = '@@input/SET_LOADING',
  SET_ERROR    = '@@input/SET_ERROR',
  RESET        = '@@input/RESET',
}

export type InputMode = 'instant' | 'explore';

export interface InputState {
  thought: string;
  mode: InputMode;
  isLoading: boolean;
  error: string | null;
}
